var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2999 6.6752L18.3749 4.6752L16.3749 3.7502L18.3749 2.8502L19.2999 0.825195L20.1999 2.8502L22.2249 3.7502L20.1999 4.6752L19.2999 6.6752ZM6.89994 6.6752L5.99994 4.6752L3.97494 3.7502L5.99994 2.8502L6.89994 0.825195L7.82494 2.8502L9.82494 3.7502L7.82494 4.6752L6.89994 6.6752ZM19.2999 19.0752L18.3749 17.0752L16.3749 16.1502L18.3749 15.2502L19.2999 13.2252L20.1999 15.2502L22.2249 16.1502L20.1999 17.0752L19.2999 19.0752ZM3.67494 21.9252L1.14994 19.4002C0.933276 19.1835 0.820776 18.9419 0.812443 18.6752C0.804109 18.4085 0.91661 18.1585 1.14994 17.9252L12.3999 6.6752C12.6166 6.45853 12.8833 6.3502 13.1999 6.3502C13.5166 6.3502 13.7833 6.45853 13.9999 6.6752L16.3999 9.0752C16.6166 9.29186 16.7249 9.55436 16.7249 9.8627C16.7249 10.171 16.6166 10.4419 16.3999 10.6752L5.14994 21.9252C4.93328 22.1585 4.68744 22.271 4.41244 22.2627C4.13744 22.2544 3.89161 22.1419 3.67494 21.9252ZM4.32494 20.2752L12.0749 12.5252L10.5249 10.9752L2.77494 18.7252L4.32494 20.2752Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagine);
export default __webpack_public_path__ + "static/media/imagine.33a4d261.svg";
export { ForwardRef as ReactComponent };